export interface Lead {
  email: string,
  name: string,
  schedule: string,
  photo?: string,
  color: string,
  accepted?: boolean,
  userPlatformId?: number,
  contactId?: string,
  sparkieUserId: string
}

export interface LeadData {
  email: string,
  name: string,
  schedule: string,
  photo?: string,
  accepted?: boolean,
  userPlatformId?: number
}

export interface GetAcceptedResponse {
  accepted: boolean,
  leadId: number | null,
  code: string | null
}

export interface PostLeadResponse {
  contactId: string,
  email: string,
  isInWindowTime: boolean,
  isParticipant: boolean,
  name: string,
  schedule: string
}

export interface LeadPayload {
  userId?: number,
  email?: string,
  name?: string,
  schedule: string,
  accept?: boolean,
  contactId?: string
}

export interface GetAcceptedPayload {
  schedule: string,
  name: string,
  email: string
}

export enum LeadVariant {
  SUCCESSFUL_SUBSCRIPTION = 'SUCCESSFUL_SUBSCRIPTION',
  LIVE_FULL = 'LIVE_FULL',
  LIVE_FULL_WITH_PLAYBACK = 'LIVE_FULL_WITH_PLAYBACK'
}
